import { Injectable } from '@angular/core';
import { LogService } from '../../../shared/services/log.service';
import { ToastService } from '../../../shared/services/toastr.service';
import { FinishState } from './finish_state';
import { RegistrationService } from '../../shared/services/registration.service';
import { MAP_SETUP_PATH } from '../../../install/shared/navigation/constants';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Angulartics2Facebook } from 'angulartics2/facebook';
import { FlowTrackingService } from '../../shared/services/flow-tracking.service';
import { take } from 'rxjs/operators';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Injectable()
export class FinishEffectsService {

  constructor(private logger: LogService,
    private toastrService: ToastService,
    private translate: TranslateService,
    private registrationService: RegistrationService,
    private redCrossService: AnalyticsTrackingProvider,
    private router: Router,
    private fbAnalytics: Angulartics2Facebook,
    private flowTrackingService: FlowTrackingService,
  ) { }

  finishRegistration(finishState: FinishState): void {
    this.registrationService.
         completeOauthFlow(finishState.originalParams).pipe(
         take(1)).subscribe(async () => {
            this.redCrossService.track('Signup Completed');
            this.flowTrackingService.StepTwoIntegrationCompleted();
            this.fbAnalytics.eventTrack('CompleteRegistration');
            this.router.navigateByUrl(MAP_SETUP_PATH);
         }, (errorResponse) => {
            this.handleError(errorResponse);
         });
  }

  private handleError(response) {
    this.logger.error(response);
    let errMsg = this.translate.instant('SIGNUP.PLATFORM.SAVE_FAILED');
    this.toastrService.error('signup', 'finishRegistration', errMsg, response);
  }
}
